import { inject } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';
import { catchError, from, Observable, throwError } from 'rxjs';
import { AuthService } from "../services/auth.service";
import { SUPPRESS_NOT_FOUND_NOTIFICATION } from '../utils/config.constants';

// Functional interceptor for errors
export function errorInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>>  {
  const snackBar = inject(MatSnackBar);
  const authService = inject(AuthService);
  
  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {

      // TODO: check todo sugli status // refresh token flow ?!
      if (error.status === 403) {
        console.log("Error 403 - Forbidden", error);
        snackBar.open('Error 403 - Forbidden', 'Close', { duration: 3000 });
      } else if (error.status === 404 && !req.context.get(SUPPRESS_NOT_FOUND_NOTIFICATION)) {
        console.log("Error 404 - Not Found", error);
        snackBar.open('Error 404 - Not Found', 'Close', { duration: 3000 });
      } else if(error.status === 401) {
        console.log("Error 401 - Unauthorized", error);
        // from(authService.logout()).subscribe(); // se necessiterà call WS
        authService.logout();
      }

      return throwError(() => error);
    })
  );
};
